// 在线用户版本更新检测
// 构建时 DefinePlugin 注入 __BUILD_VERSION__（与产物文件名、static/version.json 中的时间戳同源），
// 前端定时及切回标签页时拉取 version.json 对比，不一致则弹窗提示用户刷新，
// 避免发版后在线用户长时间停留在旧版本。
// 设计文档：docs/superpowers/specs/2026-11-02-version-update-check-design.md

var POLL_INTERVAL = 5 * 60 * 1000 // 轮询间隔：5 分钟

var timer = null   // 轮询定时器
var stopped = false // 检测到新版本后置 true，停止后续检测，避免重复弹窗
var versionBase = null // static 资源基地址（绝对地址），应用启动时刻解析并缓存

// 在应用启动时刻（任何 history pushState 之前，文档 URL 仍为入口 URL），
// 从页面实际加载的 manifest chunk 的 src 推导 static 资源基地址，
// 借 <a> 元素按此刻的页面 URL 解析为绝对地址——避免 history 路由跳到
// 多段路径后相对基准变化导致请求错位、检测静默失效
function resolveVersionBase() {
  var scripts = document.getElementsByTagName('script')
  for (var i = 0; i < scripts.length; i++) {
    var src = scripts[i].getAttribute('src') || ''
    var idx = src.indexOf('js/manifest')
    if (idx > -1) {
      var a = document.createElement('a')
      a.href = src.slice(0, idx)
      versionBase = a.href
      return
    }
  }
  // 找不到锚点时退化为相对当前入口 URL 的 static/（同样解析为绝对地址），
  // 请求失败由 checkVersion 静默处理
  var fallback = document.createElement('a')
  fallback.href = 'static/'
  versionBase = fallback.href
}

function resolveVersionUrl() {
  return versionBase + 'version.json?t=' + Date.now()
}

// 拉取 version.json 并与当前版本基准对比；
// 请求失败、非 200、解析失败一律静默忽略，等待下一轮
function checkVersion() {
  if (stopped || document.hidden) return
  var xhr = new XMLHttpRequest()
  xhr.open('GET', resolveVersionUrl(), true)
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4 || stopped) return
    if (xhr.status !== 200) return
    var remote
    try {
      remote = JSON.parse(xhr.responseText).version
    } catch (e) {
      return
    }
    if (remote == null) return // version.json 异常（无 version 字段）时静默，避免误判新版本造成无法自愈的弹窗循环
    if (String(remote) !== String(__BUILD_VERSION__)) {
      stopped = true
      clearInterval(timer)
      // 复用仅确定按钮的提示弹窗；tip.js 内部经 window.Vue 调用，启动点在 main.js 根实例创建之后
      window.Vue.$tip.confirmation(
        '检测到系统已更新，请刷新页面获取最新版本',
        '版本更新',
        function () { window.location.reload() }
      )
    }
  }
  xhr.send(null)
}

// 启动版本检测；dev 构建未注入 __BUILD_VERSION__ 时自动跳过
export function startVersionCheck() {
  if (typeof __BUILD_VERSION__ === 'undefined') return
  resolveVersionBase()
  timer = setInterval(checkVersion, POLL_INTERVAL)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) checkVersion()
  })
}



// WEBPACK FOOTER //
// ./src/assets/script/versionCheck.js